module.exports = require("node:querystring");